<template>
  <loader v-if="dataLoading" />

  <prime-dialog v-model:visible="dialog.visible" :style="{width: '1280px', height:'1440px'}" :modal="true">
    <template #header>
      <h3>Aggiungi Codice IVA</h3>
    </template>

    <div class="formgrid grid">
      <div class="field col-12 md:col-6">
        <label for="codice">Codice *</label>
        <prime-input-text 
          id="codice" 
          v-model="data.newItem.codice" 
          type="text" 
          class="inputfield w-full"
          :class="validate.errors.codice? 'p-invalid': ''"
          aria-describedby="codice-help"
        />
        <small v-if="validate.errors.codice" id="codice-help" class="p-error">Codice deve essere un numero</small>
      </div>
      <div class="field col-12 md:col-4">
        <label for="natura">Natura</label>
        <prime-input-text 
          id="natura" 
          v-model="data.newItem.natura" 
          type="text" 
          placeholder="N?"
          class="inputfield w-full" 
        />
      </div>

      <div class="field col-12">
        <label for="descrizione">Descrizione</label>
        <prime-textarea id="descrizione" v-model="data.newItem.descrizione" rows="3" class="inputfield w-full" />
      </div>

      <div class="field col-12">
        <label for="limite_euro">Eventuale limite in &euro; annuo applicabile (al di sopra di questo limite non sarà applicata la regola)</label>
        <input-number 
          id="limite_euro"
          v-model="data.newItem.limite_euro"
          mode="currency" 
          currency="EUR" 
          locale="it-IT" 
          class="inputfield w-full" 
        />
      </div>

      <div class="field col-12 md:col-6">
        <label for="esente">Esente IVA</label>
        <div>
          <prime-checkbox 
            id="esente" 
            v-model="data.newItem.esente" 
            :binary="true"
            class="inputfield w-full"
          />
        </div>
      </div>
      <div class="field col-12 md:col-6">
        <label for="bollo">Bollo</label>
        <div>
          <prime-checkbox 
            id="bollo" 
            v-model="data.newItem.bollo" 
            :binary="true"
            class="inputfield w-full"
          />
        </div>
      </div>

      <div class="field col-12 md:col-6">
        <label for="esente">Differita</label>
        <div>
          <prime-checkbox 
            id="differito" 
            v-model="data.newItem.differito" 
            :binary="true"
            class="inputfield w-full"
          />
        </div>
      </div>
      <div class="field col-12 md:col-6">
        <label for="iva_differita">IVA Differita</label>
        <div>
          <prime-input-text 
            id="iva_differita" 
            v-model="data.newItem.iva_differita" 
            type="text" 
            placeholder="22"
            :disabled="!data.newItem.differito"
            class="inputfield w-full" 
          />
        </div>
      </div>
    </div>

    <div class="p-d-flex p-p-3 card">
      <prime-button label="Aggiungi" class="mb-auto" @click="onAddNewCodice($event)" />
    </div>

    <template #footer>
      <prime-button label="Chiudi" icon="pi pi-check" @click="onCloseDialog($event)" autofocus />
    </template>
  </prime-dialog>

  <div class="page">

    <data-table :value="data.codici" dataKey="id" responsiveLayout="scroll">
      <column field="codice" header="Codice"></column>
      <column field="natura" header="Natura"></column>
      <column field="descrizione" header="Descrizione"></column>
      <column field="limite_euro" header="Limite Euro">
        <template #body="{data}">
          {{ (data.limite_euro !== null)? currencyFormatter.format( data.limite_euro ): ''}}
        </template>
      </column>
      <column field="esente" header="Esente">
        <template #body="{data}">
          {{ (data.esente)? 'SI' : 'NO' }} 
        </template>
      </column>
      <column field="bollo" header="Bollo">
        <template #body="{data}">
          {{ (data.bollo)? 'SI' : 'NO' }} 
        </template>
      </column>
      <column field="differito" header="Differito">
        <template #body="{data}">
          {{ (data.differito)? 'SI' : 'NO' }} 
        </template>
      </column>
      <column field="iva_differita" header="IVA Differita">
        <template #body="{data}">
          {{ data.iva_differita }} 
        </template>
      </column>
      <column :exportable="false">
        <template #body="{data}">
          <prime-button 
            icon="pi pi-trash" 
            class="p-button-rounded p-button-success mr-2" 
            @click="onDeleteCodice(data.id)" 
          />
        </template>
      </column>
    </data-table>

    <div class="p-d-flex p-p-3 card">
      <prime-button label="Aggiungi Codice IVA" icon="pi pi-file-pdf" class="mb-auto" @click="dialog.visible = true" />
    </div>
    
  </div>
</template>

<script>
import moment from 'moment'

import Service from '@/services/ask-management/utility-codici-iva-service'

import Loader from '@/components/Loader.vue'

import PrimeCheckbox from 'primevue/checkbox'
import PrimeButton from 'primevue/button'
import PrimeDialog from 'primevue/dialog'
import PrimeInputText from 'primevue/inputtext'
import PrimeTextarea from 'primevue/textarea'

export default { 
  components: {
    Loader,
    PrimeCheckbox,
    PrimeButton,
    PrimeDialog,
    PrimeInputText,
    PrimeTextarea,
  },

  data() {
    return {
      moment,

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      dataLoading: false,

      dialog:{
        visible: false,
      },

      validate: {
        errors:{
          codice: false
        }
      },

      data: {
        codici: [],

        newItem: {
          codice: "",
          natura: "",
          descrizione: "",
          limite_euro: null,
          bollo: true,
          esente: false,
          differito: false,
          iva_differita: null,
        }
      },
    }
  },

  created(){
    this.service = new Service(this.$http, this.$eventBus)
    this.getCodici()
  },

  methods:{

    onCloseDialog(/** event **/){
      this.dialog.visible = false
      this.resetNewItem()
    },

    onAddNewCodice(/** event **/){
      if( !( !isNaN(this.data.newItem.codice) && !isNaN(parseInt(this.data.newItem.codice))  ) ){
        this.validate.errors.codice = true
      }else{
        this.validate.errors.codice = false
      }

      if(!this.validate.errors.codice){

        if(!this.data.newItem.differito){
          this.data.newItem.iva_differita = null
        }

        this.service.createCodice(this.data.newItem).then((res) => {
          if(res.success){
            this.getCodici()

            this.dialog.visible = false
            this.resetNewItem()
          }else{
            alert("Ci sono stati problemi durante l'inserimento")
          }
        })

      }
    },

    onDeleteCodice(id){
      this.service.deleteCodice(id).then((res) => {
        if(res.success){
          this.getCodici()
        }
      })
    },

    /////

    navigateToTab(href){
      window.open(href, '_blank')
    },

    resetNewItem(){
      this.validate.errors.codice = false

      this.data.newItem.codice = ""
      this.data.newItem.natura = ""
      this.data.newItem.descrizione = ""
      this.data.newItem.limite_euro = null
      this.data.newItem.bollo = true
      this.data.newItem.esente = false
      this.data.newItem.differito = false
      this.data.newItem.iva_differita = null
    },

    getCodici(){
      this.dataLoading = true

      this.service.getCodici().then((res) => {
        this.data.codici = res.items
      }).finally(() =>{
        this.dataLoading = false
      })
    },

  },

  computed:{
    
  },

  watch: {
    
  },
}
</script>

<style scoped>
.box-center{
  text-align: center;
}
</style>
